'use strict'

import HtmlUtils from "../../../components/HtmlUtils.js";

export default class StatisticFunctionConfigDialog {
    constructor() {
        this._dialog = null;
        this._callbacks = [];
    }

    /**
     * @param {string} eventName
     * @param {function} callback
     */
    on(eventName, callback){
        this._callbacks[eventName] = callback;
    }

    /**
     * @param {string} body
     * @returns {StatisticFunctionConfigDialog}
     */
    render(body) {
        if (this._dialog)
            this._dialog.remove();
        this._dialog = this._createModal(StatisticFunctionConfigDialog._htmlTemplate(body));

        const colorPreview = this._dialog.querySelector('.color-preview-rect');
        const colorPalette = this._dialog.querySelector('color-palette');
        this._dialog.querySelector('#function-style-color').addEventListener('click', () => {
            colorPalette.show({color: colorPreview.style.backgroundColor})
        })
        colorPalette.addEventListener('colorChanged', () => {
            colorPreview.style.backgroundColor = colorPalette.getCurrentColor();
        })
        colorPalette.addEventListener('onClose', () => {
            colorPalette.hide();
        })

        let cancelBtn = this._dialog.querySelector('.btn-cancel');
        cancelBtn.addEventListener('click', ()=>{
            this.remove();
            if (this._callbacks['cancel']) this._callbacks['cancel']();
        })

        let okBtn = this._dialog.querySelector('.btn-ok');
        okBtn.addEventListener('click', ()=>{
            const inputs = this._dialog.querySelectorAll('text-input')
            for (const input of inputs){
                if (!input.checkValidity()){
                    input.focus();
                    return;
                }
            }
            this._dialog.querySelector('.progress').style.display = 'block';
            okBtn.setAttribute('disabled', true);
            if (this._callbacks['ok']) this._callbacks['ok']();
            this.remove();
        });
        let deleteBtn = this._dialog.querySelector('.btn-delete');
        deleteBtn.addEventListener('click', ()=>{
            this.remove();
            if (this._callbacks['delete']) this._callbacks['delete']();
        })

        this._dialog.addEventListener('keydown', (evt) => {
            evt.stopPropagation();
            if (evt.repeat) return;
            switch (evt.key) {
                case 'Enter' : {
                    if (!okBtn.getAttribute('disabled') === true)
                        okBtn.dispatchEvent(new Event('click'))
                    break;
                }
                case 'Escape' :
                    cancelBtn.dispatchEvent(new Event('click'))
            }
        })
        this._dialog.focus();

        return this;
    }

    remove() {
        this._dialog.remove();
    }

    _createModal(node) {
        return HtmlUtils.createModal(node);
    }

    /**
     * @param {string} body
     * @returns {Node}
     * @private
     */
    static _htmlTemplate(body) {
        let tmpl = document.createElement('template');
        tmpl.innerHTML = `
            <div id="two-buttons-dialog" class="dialog statistic-function-config-dialog">
              <div class="progress">
                <div class="indeterminate"></div>
              </div>
              <div class="dialog-content">
                ${body}
              </div>
              <div class="dialog-buttons-row">
               <div class="justify-start"><button class="button button--text button--text-red btn-delete">Delete</button></div>
               <button class="button button--text btn-cancel">Cancel</button>
               <button class="button button--contained btn-ok">Ok</button>
                
              </div>
            </div>`
        ;
        return tmpl.content.cloneNode(true);
    }
}